export default {
  props: {
    sty: {
      default: ''
    },
    size: {
      default: ''
    }
  }
};